'use client'

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import { User } from '@/lib/types'
import { FileTextIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { ChatKitPageWrapper } from '../_components/chatkit-page-wrapper'
import { ChatKitLoginGate } from '../_components/chatkit-login-gate'
import { getChatKitConstants } from './_const'

interface IBusinessPlanClientProps {
  user: User | null
  userApiKey: string
  hasApiKey: boolean
}

/**
 * Client component for Business Plan Generator
 * Handles ChatKit integration and user interactions
 */
export default function BusinessPlanClient({
  user,
  userApiKey,
  hasApiKey,
}: IBusinessPlanClientProps) {
  const t = useTranslations('business-plan')
  const constants = getChatKitConstants(t)

  if (!user) {
    return (
      <ChatKitLoginGate
        icon={FileTextIcon}
        title="Log in to build plans with AI"
        description="Preview the Business Plan Agent’s workflow. Sign in to customize models, save drafts, and export investor-ready documents."
        redirectUrl="/chatkit/business-plan"
      />
    )
  }

  if (!hasApiKey) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <FileTextIcon />
          </EmptyMedia>
          <EmptyTitle>No API Key</EmptyTitle>
          <EmptyDescription>
            Generate an API key inside your workspace settings to unlock the
            Business Plan Agent.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    )
  }

  return (
    <ChatKitPageWrapper
      user={user}
      userApiKey={userApiKey}
      workflowKey="business_plan"
      constants={constants}
      t={t}
      icon={FileTextIcon}
    />
  )
}
